import { html, nothing, svg, type TemplateResult } from "lit";

const ICON_DOC = svg`<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="15" x2="15" y2="15"/></svg>`;
const ICON_CHEVRON = svg`<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>`;

export interface FamilyWaiverViewModel {
  enabled: boolean;
  open: boolean;
  agreed: boolean;
  paragraphs: readonly string[];
  onToggleEnabled: () => void;
  onToggleOpen: () => void;
  onToggleAgreed: (agreed: boolean) => void;
}

export function renderFamilyWaiver(
  model: FamilyWaiverViewModel,
): TemplateResult {
  return html`
    <div class="self-row" style="margin-top:0">
      <div>
        <div class="t">Sign the waiver on behalf of this family member</div>
        <div class="s">
          Complete this activity's liability waiver for them now.
        </div>
      </div>
      <span
        class="switch ${model.enabled ? "on" : ""}"
        style="margin-left:auto"
        @click=${model.onToggleEnabled}
      ></span>
    </div>
    ${model.enabled
      ? html`<div class="waiver">
          <button class="waiver-head" @click=${model.onToggleOpen}>
            <span class="ic">${ICON_DOC}</span>
            <span style="flex:1;min-width:0">
              <span class="t" style="display:block">Liability waiver</span>
              <span class="s"
                >${model.open
                  ? "Tap to collapse"
                  : "Tap to read full waiver"}</span
              >
            </span>
            <span class="chev ${model.open ? "open" : ""}"
              >${ICON_CHEVRON}</span
            >
          </button>
          ${model.open
            ? html`<div class="waiver-body">
                ${model.paragraphs.map(
                  (paragraph) => html`<p>${paragraph}</p>`,
                )}
              </div>`
            : nothing}
          <label class="waiver-check">
            <input
              type="checkbox"
              .checked=${model.agreed}
              @change=${(event: Event) =>
                model.onToggleAgreed(
                  (event.target as HTMLInputElement).checked,
                )}
            />
            I've read and agree to the liability waiver on this family member's
            behalf.
          </label>
        </div>`
      : nothing}
  `;
}

export interface BookingWaiverViewModel {
  name: string;
  open: boolean;
  checked: boolean;
  paragraphs: readonly string[];
  fields: readonly (TemplateResult | typeof nothing)[];
  error: string;
  onToggleOpen: () => void;
  onToggleChecked: (checked: boolean) => void;
}

export function renderBookingWaiver(
  model: BookingWaiverViewModel,
): TemplateResult {
  return html`
    <div class="waiver">
      <button class="waiver-head" @click=${model.onToggleOpen}>
        <span class="ic">${ICON_DOC}</span>
        <span style="flex:1;min-width:0">
          <span class="t" style="display:block"
            >${model.name || "Liability waiver"}</span
          >
          <span class="s"
            >${model.open ? "Tap to collapse" : "Tap to read full waiver"}</span
          >
        </span>
        <span class="chev ${model.open ? "open" : ""}">${ICON_CHEVRON}</span>
      </button>
      ${model.open
        ? html`<div class="waiver-body">
            ${model.paragraphs.map((paragraph) => html`<p>${paragraph}</p>`)}
          </div>`
        : nothing}
      ${model.fields.length
        ? html`<div class="waiver-fields">${model.fields}</div>`
        : nothing}
      <label class="waiver-check">
        <input
          type="checkbox"
          .checked=${model.checked}
          @change=${(event: Event) =>
            model.onToggleChecked((event.target as HTMLInputElement).checked)}
        />
        I've read and agree to the liability waiver. I'm participating at my own
        risk and have no conditions that prevent safe practice.
      </label>
      ${model.error
        ? html`<div class="err" style="padding:0 0.875rem 0.75rem">
            ${model.error}
          </div>`
        : nothing}
    </div>
  `;
}
